import useRole from 'components/GenericsHooks/useRoles';
import useLoad from 'components/hooks/useLoad';
import {course} from '../../../constants/url';

function useLoadCourse() {
  const role = useRole();
  return useLoad(course, 'iD_Course', {role});
}

export default useLoadCourse;
